<div class="ganntCard">
  <span *ngIf="showChart">
    <google-chart
      #gantt
      [data]="chart"
      (chartSelect)="openTask($event)"
    ></google-chart>
  </span>
</div>
